import util from './util'

function _openGallery(e) {
	let srcs = []
	let images = $(e.currentTarget).closest('.gallery-inner').children('.img-placeholder')
	if (!images.length) {
		images = $(e.currentTarget).siblings('.gallery-inner').children('.img-placeholder')
	}
	let index = $(e.currentTarget).index()

	for (var i = 0; i < images.length; i++) {
		srcs.push({
			src: $(images[i]).data('src'),
			caption: $(images[i]).data('caption')
		})
	}

	this.$root.$refs.lightbox.open(srcs, index)
}

let SingleTimeline = Vue.component('single-timeline', {
	props: ['items'],
	methods: {
		openGallery: _openGallery
	},
	mounted() {

		if (!this.items) {
			return
		}

		for (let i = 0; i < this.items.length; i++) {
			if (this.items[i].post) {

				let id = this.items[i].post.ID

				util.getPermalinkFromID(id).then((link) => {
					Vue.set(this.items[i].post, 'permalink', JSON.parse(link))
				})

				util.getMultilineTitleFromID(id).then((title) => {

					let response = JSON.parse(title)

					// Check if response is HTML = actual multiline

					try {
						$(response).is('p')
						Vue.set(this.items[i].post, 'multi_line_title', response)
					} catch (e) {
						// Do nothing
					}

				})

				util.getAuthorMeta(id).then((meta) => {

					let authorString

					switch (JSON.parse(meta)) {
						case 'jesper':
							authorString = 'Jesper Olsson'
							break;
						case 'jonas':
							authorString = 'Jonas Ingvarsson'
							break;
						case 'jakob':
							authorString = 'Jakob Lien'
							break;
						case 'cilla':
							authorString = 'Cecilia Lindhé'
							break;
						case 'all':
							authorString = 'All contributors'
							break;
						default:
					}

					Vue.set(this.items[i].post, 'author_pretty_name', ' <span style="display: inline-block;">by ' + authorString + '</span>')

				})
			}
		}

	},
	template: `
		<ul class="post-list">
			<li v-for="item in items" v-if="item.file || item.images || item.post" :class="{ 'gallery-li' : item.images }">
				<div v-if="item.acf_fc_layout == 'gallery'" class="gallery">
					<span data-cursor="gallery" class="gallery-label" @click="openGallery">{{ item.filename }}</span>
					<div class="gallery-inner">
						<div class="img-placeholder img-placeholder--unrendered" @click="openGallery" v-for="image in item.images" :style="{ width: '20%' }" :data-thumb-src="image.sizes.thumbnail" :data-src="image.url" :data-caption="image.caption" alt="">
							<div class="img-overlay"></div>
						</div>
					</div>
				</div>
				<a v-else-if="item.acf_fc_layout == 'file'" :href="item.file.url" target="_blank" data-cursor="file">{{item.file.filename}}</a>
				<a v-else-if="item.acf_fc_layout == 'post' && item.post" class="ajax" :href="item.post.permalink" :data-id="item.post.ID" :data-slug="item.post.name" data-cursor="internal" v-html="item.post.multi_line_title ? item.post.multi_line_title + item.post.author_pretty_name : item.post.post_title"></a><p></p>
			</li>
			<p v-if="!items">No documentation</p>
		</ul>`
})



export default SingleTimeline
